
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from "react";
import RegisterInfo from "@components/Register/RegisterInfo";
import RenderMeta from "@utils/RenderMeta";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import RegisterFormWrapper from "@components/Register/RegisterFormWrapper";
const OtpModal = React.memo(dynamic(() => import("@components/modals/OtpModal"), {
    ssr: false
}));
const Register = () => {
    const [otpModal, setOtpModal] = useState({ open: false });
    const { t } = useTranslation("register");
    return (<>
      <RenderMeta title={`${t("form_title")} | ${t("common-locale:aseel")}`} description={t("common-locale:global_description")} img={"/images/ogi/home.jpg"} newtag={<link rel="preload" as="image" href={`/images/background/back-login.webp`}/>}/>
      <div style={{
            backgroundSize: "auto",
            backgroundImage: "url(/images/background/back-login.webp)"
        }} className="flex flex-col lg:flex-row w-full lg:h-screen">
        <RegisterInfo />
        <RegisterFormWrapper setOtpModal={setOtpModal}/>

        {otpModal?.open ? (<OtpModal {...otpModal} onClose={() => setOtpModal({ open: false })}/>) : null}
      </div>
    </>);
};
export default Register;

    async function __Next_Translate__getStaticProps__195bb8c458f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/register',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195bb8c458f__ as getStaticProps }
  